import React, { useState } from "react";
import { Layout, Menu, Breadcrumb } from "antd";
import ReactMarkdown from 'react-markdown';
import remarkGfm from 'remark-gfm';

const { Content, Sider } = Layout;

const graphs = [
  {
    id: "graph1",
    title: "Evolución en el tiempo",
    menuTitle: "Evolución en el tiempo",
    text: `La proporción de estudiantes que presentan inasistencia grave ha variado de forma significativa desde 2018. En el primer año de la serie, un 18% de las y los 
          estudiantes faltaron a más del 15% de las clases. En 2022 la inasistencia alcanzó su punto más alto con un 36% y en los años posteriores comenzó a descender. 
          En 2024, último año de medición, la inasistencia fue de un 27%.`,
    link: "https://public.flourish.studio/visualisation/25664306/embed",
  },
  {
    id: "graph2",
    title: "Análisis por sexo",
    menuTitle: "\u2022 Sexo",
    text: `No se observan mayores diferencias de acuerdo al sexo de las y los estudiantes en la proporción que presenta inasistencia grave.`,
    link: "https://public.flourish.studio/visualisation/25666119/embed",
  },
  {
    id: "graph3",
    title: "Análisis por curso",
    menuTitle: "\u2022 Curso",
    text: `La inasistencia no se distribuye de igual forma a lo largo del ciclo educativo. Los cursos con mayor inasistencia grave en 2024 son 1° básico y 3° medio 
          técnico-profesional, con un 33% y 31%, respectivamente. Luego, lo sigue 4° medio técnico-profesional, con un 30%. Es interesante notar que en 2018, la 
          inasistencia grave se concentraba en la educación media, pero a partir de 2022 la proporción entre los ciclos educativos ha tendido a equipararse.`,
    link: "https://public.flourish.studio/visualisation/25666497/embed",
  },
  {
    id: "graph4",
    title: "Análisis por nacionalidad",
    menuTitle: "\u2022 Nacionalidad",
    text: `En cuanto a la nacionalidad, un 29% de las niñas y niños nacidos en otro país presentó inasistencia grave, frente al 27% de quienes nacieron en Chile. Desde 
          2018, la inasistencia ha sido consistentemente mayor entre la población que nació fuera del país; sin embargo, esta brecha se ha ido acercando.`,
    link: "https://public.flourish.studio/visualisation/25667183/embed",
  },
  {
    id: "graph5",
    title: "Análisis por dependencia administrativa",
    menuTitle: "\u2022 Dependencia",
    text: `En toda la serie, incluyendo la última medición, los colegios que presentan menor inasistencia grave corresponden a los colegios subvencionados. Las otras 
          tres dependencias restantes, si bien han tenido tendencias distintas, en 2024 la brecha se acercó, particularmente entre SLEP (36%) y los colegios particulares 
          pagados (35%).`,
    link: "https://public.flourish.studio/visualisation/25666253/embed",
  },
  {
    id: "graph6",
    title: "Análisis por zona de residencia",
    menuTitle: "\u2022 Zona",
    text: `Independientemente de la zona de residencia de niñas y niños, en ambos grupos hubo un aumento importante en la inasistencia entre el periodo pre y post 
          pandemia. Sin embargo, las y los estudiantes que asisten a colegios en zonas urbanas presentan una mayor inasistencia grave que los de zonas rurales. `,
    link: "https://public.flourish.studio/visualisation/25666299/embed",
  },
  {
    id: "graph7",
    title: "Análisis por macrozona",
    menuTitle: "\u2022 Macrozona",
    text: `En todas las macrozonas del país aumentó la proporción de estudiantes con inasistencia grave entre 2018 y 2024. Históricamente, las y los estudiantes de la 
          Macrozona Norte han registrado los niveles más altos de inasistencia. En 2024, la cifra en esta macrozona alcanzó un 31%.`,
    link: "https://public.flourish.studio/visualisation/25666649/embed",
  },
  {
    id: "graph8",
    title: "Análisis por región",
    menuTitle: "\u2022 Región",
    text: `Al estimar el indicador de acuerdo a la región se observan variaciones importantes. Si bien en todas las regiones del país hay un alza entre el periodo pre y 
          post pandemia, hay regiones que en todos los años de medición han tenido proporciones altas de inasistencia. En 2024, la región de Atacama fue la que presentó 
          una mayor proporción, pero ya en 2019, donde la proporción del país era de un 28%, la región tenía un 63%. Aunque en menor medida, las regiones de Aysén y la 
          Metropolitana también han registrado históricamente una alta proporción de inasistencia.`,
    link: "https://public.flourish.studio/visualisation/25666708/embed",
  }
];

const App = () => {
  const [collapsed, setCollapsed] = useState(false);
  const [selectedMenuItem, setSelectedMenuItem] = useState("graph1");

  const handleMenuItemClick = (graphId, graphTitle) => {
    setSelectedMenuItem(graphId);
  };

  const toggleCollapsed = () => {
    setCollapsed(!collapsed);
  };

  const selectedGraph = graphs.find((graph) => graph.id === selectedMenuItem);

  return (
    <Layout style={{ minHeight: "100vh" }}>
      <Sider
        width={250}
        collapsible
        collapsed={collapsed}
        onCollapse={toggleCollapsed}
        style={{ background: "#fff" }}
        breakpoint="lg"
        collapsedWidth={0}
      >
        <Menu theme="dark" mode="vertical" selectedKeys={[selectedMenuItem]} style={{ background: "#fff" }}>
          {graphs.map((graph) => (
            <Menu.Item
              key={graph.id}
              onClick={() => handleMenuItemClick(graph.id)}
              style={{ color: 'black', paddingLeft: graph.id !== "graph1" ? "30px" : "20px" }}
            >
              {graph.menuTitle}
            </Menu.Item>
          ))}
        </Menu>
      </Sider>
      <Layout style={{ padding: "24px 24px 24px" }}>
        <Breadcrumb style={{ margin: "16px 0" }}>
          <Breadcrumb.Item></Breadcrumb.Item>
        </Breadcrumb>
        <Content
          id="content"
          style={{
            background: "#ffff",
            padding: 24,
            margin: 0,
            minHeight: 280,
          }}
        >
          {selectedGraph && (
            <div>
              <div style={{ marginBottom: 16 }}>
                <h1>{selectedGraph.title}</h1>
              </div>
              <div style={{ textAlign: 'justify' }}>
                <ReactMarkdown remarkPlugins={[remarkGfm]}>
                  {selectedGraph.text}
                </ReactMarkdown>
              </div>
              <iframe
                src={selectedGraph.link}
                frameBorder="0"
                scrolling="no"
                style={{ minWidth: "100%", height: "500px" }}
              ></iframe>
            </div>
          )}
        </Content>
      </Layout>
    </Layout>
  );
};

export default App;

